module.exports = __webpack_public_path__ + "img/coleslaw_blandet.0b0d9f91.jpg";